import { render, staticRenderFns } from "./orgitemviewFooter.vue?vue&type=template&id=18252d1a"
import script from "./orgitemviewFooter.vue?vue&type=script&lang=js"
export * from "./orgitemviewFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports